import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Link} from 'react-router-dom';
import {Modal} from 'antd';

import ImgMenu1 from '@/shared/pictures/menu_1.png';
import ImgMenu2 from '@/shared/pictures/menu_2.png';
import ImgMenu3 from '@/shared/pictures/menu_3.png';
import ImgMenu4 from '@/shared/pictures/menu_4.png';
import ImgMenu5 from '@/shared/pictures/menu_5.png';
import ImgMenu6 from '@/shared/pictures/menu_6.png';
import ImgMenu7 from '@/shared/pictures/menu_7.png';
import ImgMenu8 from '@/shared/pictures/menu_8.png';
import ImgMenu9 from '@/shared/pictures/menu_9.png';
import ImgMenu10 from '@/shared/pictures/menu_10.png';
import ImgSecret from '@/shared/pictures/secret.png';
import ImgClose from '@/shared/pictures/close.svg';

export const MenuPage = observer(() => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <div className='menu-page'>

            <div className="container">

                <div className='menu-page_items'>

                    {/* <Link to='tracker' className='menu-page_item'>
              <h2 className='menu-page_title'>Спортивный трекер</h2>
              <img className='menu-page_img' src={ImgMenu1} alt="menu-img" />
            </Link>
            <div className='menu-page_item' onClick={()=>setIsModalOpen(true)}>
              <h2 className='menu-page_title'>OVI Sports Club</h2>
              <img className='menu-page_img' src={ImgMenu2} alt="menu-img" />
            </div> */}
                    <Link to='lucky' className='menu-page_item'>
                        <h2 className='menu-page_title'>Клюшка удачи</h2>
                        <img className='menu-page_img' src={ImgMenu3} alt="menu-img"/>
                    </Link>
                    <Link to='training' className='menu-page_item'>
                        <h2 className='menu-page_title'>Тренировки</h2>
                        <img className='menu-page_img' src={ImgMenu4} alt="menu-img"/>
                    </Link>
                    <Link to='teams' className='menu-page_item'>
                        <h2 className='menu-page_title'>Команды</h2>
                        <img className='menu-page_img' src={ImgMenu8} alt="menu-img"/>
                    </Link>
                    <Link to='forecast' className='menu-page_item'>
                        <h2 className='menu-page_title'>Прогнозы</h2>
                        <img className='menu-page_img' src={ImgMenu9} alt="menu-img"/>
                    </Link>
                    {/* <div onClick={()=>setIsModalOpen(true)} className='menu-page_item'>
                            <h2 className='menu-page_title'>Секретное меню</h2>
                            <img className='menu-page_img' src={ImgMenu6} alt="menu-img" />
                        </div>
                     */}
                    <Link to='inventory' className='menu-page_item menu-page_item-full'>
                        <h2 className='menu-page_title'>Инвентарь</h2>
                        <img className='menu-page_img menu-page_img-full' src={ImgMenu7} alt="menu-img"/>
                    </Link>

                    {/*<Link to='quests' className='menu-page_item menu-page_item-full'>*/}
                    {/*    <h2 className='menu-page_title'>Задания</h2>*/}
                    {/*    <img className='menu-page_img menu-page_img-full' src={ImgMenu10} alt="menu-img"/>*/}
                    {/*</Link>*/}

                </div>

                <Modal
                    title=''
                    open={isModalOpen}
                    footer={null}
                    closeIcon={<img src={ImgClose} onClick={() => handleCancel()}/>}
                >
                    <div className='modal secret'>
                        <img src={ImgSecret} className='modal_image' alt="img"/>
                        <p className='modal_text'>Проявляй активность! <br/>Мы сообщим тебе когда будет открыт доступ к
                            этому меню</p>
                    </div>
                </Modal>
            </div>
        </div>
    );
});
